import { Reveal } from "@/lib/motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQ } from "@/lib/site";

export const Faq = () => {
  return (
    <section id="faq" className="relative py-24 sm:py-32" data-testid="faq-section">
      <div className="mx-auto max-w-3xl px-4 sm:px-8">
        <Reveal className="mb-12 text-center">
          <p className="mb-3 text-xs uppercase tracking-[0.25em] text-[#F0C674]/80">
            Глава 06 — Частые вопросы
          </p>
          <h2 className="font-serif text-4xl font-bold text-[#EDE6D3] sm:text-5xl lg:text-6xl">
            Вопросы и <span className="text-gold-gradient">ответы</span>
          </h2>
        </Reveal>

        <Reveal delay={0.1}>
          <Accordion
            type="multiple"
            defaultValue={["item-0", "item-1"]}
            className="space-y-4"
          >
            {FAQ.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="overflow-hidden rounded-2xl border border-[#D4AF6E]/12 bg-surface px-6"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="py-5 text-left font-serif text-lg font-semibold text-[#EDE6D3] hover:text-[#F0C674] hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-5 text-sm leading-relaxed text-[#EDE6D3]/65">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
